export default "__VITE_ASSET__FE7O5h7y__"